import { Modal } from 'antd';
import styled from 'styled-components';

export const ModalCustom = styled(Modal)`
  z-index: 10000 !important;
  .ant-modal-close-x {
    display: none;
  }
  .ant-modal-footer {
    display: flex;
    justify-content: end;
  }
  .ant-modal-content {
    background: transparent;
    box-shadow: none;
  }
`;

export const Loading = styled.div`
  body {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  div {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: inline-block;
    margin: 0.5rem;
    animation: loading 2.5s ease-in-out infinite;
  }

  @keyframes loading {
    0%,
    100% {
      transform: scale(0.2);
      background-color: #f8d10d;
    }
    42% {
      background-color: #ff9500;
    }
    50% {
      transform: scale(1);
      background-color: #ff8400b8;
    }
  }

  div:nth-child(0) {
    animation-delay: 0s;
  }
  div:nth-child(1) {
    animation-delay: 0.2s;
  }
  div:nth-child(2) {
    animation-delay: 0.4s;
  }
  div:nth-child(3) {
    animation-delay: 0.6s;
  }
  div:nth-child(4) {
    animation-delay: 0.8s;
  }
  div:nth-child(5) {
    animation-delay: 1s;
  }
`;
